import { useState, useEffect, useCallback } from "react";
import loadingSlidesData from "../data/loadingSlides.json";

export const useLoadingAnimation = (onComplete) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [showWhosNext, setShowWhosNext] = useState(false);

  const slides = loadingSlidesData.slides;
  // 모든 슬라이드 동일한 타이밍으로 빠르게 진행
  const SLIDE_DURATION = 800; // 0.8초 - 모든 슬라이드 동일
  const LAST_SLIDE_DURATION = 800; // 마지막 슬라이드도 동일하게 0.8초
  const WHOS_NEXT_DURATION = 2500; // WHO'S NEXT 2.5초 (유지 시간 확보)

  const startAnimation = useCallback(() => {
    setIsAnimating(true);
    setCurrentSlide(0);
    setShowWhosNext(false);
  }, []);

  useEffect(() => {
    if (!isAnimating) return;

    let timer;
    console.log(
      "useLoadingAnimation - currentSlide:",
      currentSlide,
      "showWhosNext:",
      showWhosNext,
      "slides.length:",
      slides.length
    );

    if (currentSlide < slides.length) {
      // 더 빠른 타이밍으로 조정
      let duration;
      if (currentSlide === slides.length - 1) {
        duration = LAST_SLIDE_DURATION; // 마지막 슬라이드 0.6초
      } else {
        duration = SLIDE_DURATION; // 일반 슬라이드 0.8초
      }

      console.log(`Slide ${currentSlide} - duration: ${duration}ms`);
      timer = setTimeout(() => {
        console.log(`Moving to next slide from ${currentSlide}`);
        setCurrentSlide((prev) => prev + 1);
      }, duration);
    } else if (!showWhosNext) {
      // 슬라이드쇼 완료 후 바로 배경 영상 시작
      console.log("Slides complete - starting background video immediately");
      setShowWhosNext(true);
      timer = setTimeout(() => {
        console.log("Animation complete - calling onComplete");
        setIsAnimating(false);
        onComplete?.();
      }, WHOS_NEXT_DURATION);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [currentSlide, isAnimating, showWhosNext, slides.length, onComplete]);

  return {
    currentSlide,
    showWhosNext,
    isAnimating,
    startAnimation,
    slides,
    progress:
      ((currentSlide + (showWhosNext ? 1 : 0)) / (slides.length + 1)) * 100,
    // 단축된 타이밍 정보
    timingConfig: {
      SLIDE_DURATION,
      LAST_SLIDE_DURATION,
      WHOS_NEXT_DURATION,
    },
  };
};
